import token, { tokenToVars } from '../token';
import Card from './card';

export { Card };
export default tokenToVars(Card, token);
